import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dispatcherpanel" }
const _hoisted_2 = { class: "bg-white border px-6 py-4 flex flex-col" }
const _hoisted_3 = { class: "mt-3 flex justify-between" }
const _hoisted_4 = { class: "flex items-center mt-3" }
const _hoisted_5 = { class: "flex items-center ml-5" }
const _hoisted_6 = { class: "flex items-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_submit_orders = _resolveComponent("submit-orders")!
  const _component_submit_order = _resolveComponent("submit-order")!
  const _component_submit_checked_orders = _resolveComponent("submit-checked-orders")!
  const _component_change_date = _resolveComponent("change-date")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_loader = _resolveComponent("loader")!
  const _component_orders = _resolveComponent("orders")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_submiting_orders)
      ? (_openBlock(), _createBlock(_component_submit_orders, {
          key: 0,
          "dispatcher-sector-id": _ctx.state.dispatcher_sector_id,
          onCancel: _ctx.cancelSubmitOrders,
          onSubmited: _ctx.cancelSubmitOrders
        }, null, 8, ["dispatcher-sector-id", "onCancel", "onSubmited"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_submiting_order)
      ? (_openBlock(), _createBlock(_component_submit_order, {
          key: 1,
          "order-id": _ctx.state.selected_order_id,
          "dispatcher-sector-id": _ctx.state.dispatcher_sector_id,
          onCancel: _ctx.cancelSubmitOrder,
          onSubmited: _ctx.onOrderSubmited
        }, null, 8, ["order-id", "dispatcher-sector-id", "onCancel", "onSubmited"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_submiting_checked_orders)
      ? (_openBlock(), _createBlock(_component_submit_checked_orders, {
          key: 2,
          "checked-orders-ids": _ctx.state.selected_orders_ids,
          "dispatcher-sector-id": _ctx.state.dispatcher_sector_id,
          onCancel: _ctx.cancelSubmitCheckedOrders,
          onSubmited: _ctx.cancelSubmitCheckedOrders
        }, null, 8, ["checked-orders-ids", "dispatcher-sector-id", "onCancel", "onSubmited"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_changing_date)
      ? (_openBlock(), _createBlock(_component_change_date, {
          key: 3,
          "order-id": _ctx.state.selected_order_id,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.is_changing_date = false)),
          onChanged: _ctx.onDateChanged
        }, null, 8, ["order-id", "onChanged"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_the_select, {
        value: _ctx.state.dispatcher_sector_id,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.dispatcher_sector_id) = $event)),
        placeholder: "Выберите сектор диспетчера",
        loading: _ctx.dispatcherSectors.is_loading,
        options: _ctx.dispatcherSectors.list,
        failed: _ctx.dispatcherSectors.is_failed,
        "error-text": "При получении списка секторов диспетчера произошла ошибка",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        onRefresh: _ctx.loadDispatcherSectors,
        onChange: _ctx.loadTakeOrdersAndSectors
      }, null, 8, ["value", "loading", "options", "failed", "onRefresh", "onChange"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_input, {
          type: "date",
          value: _ctx.state.from_date,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.from_date) = $event)),
          placeholder: "Дата забора от",
          onChange: _ctx.reloadOrders
        }, null, 8, ["value", "onChange"]),
        _createVNode(_component_the_input, {
          class: "ml-3",
          type: "date",
          value: _ctx.state.to_date,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.to_date) = $event)),
          placeholder: "Дата забора до",
          onChange: _ctx.reloadOrders
        }, null, 8, ["value", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_checkbox, {
          label: "Отображать сектора доставки",
          disabled: !Boolean(_ctx.state.dispatcher_sector_id),
          value: _ctx.state.is_delivery_sectors_showed,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.is_delivery_sectors_showed) = $event)),
          onChange: _ctx.onToggleShowDeliverySectors
        }, null, 8, ["disabled", "value", "onChange"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_checkbox, {
            label: "Автозабор",
            value: _ctx.state.auto_assign_enable,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.auto_assign_enable) = $event)),
            disabled: 
                            !Boolean(_ctx.state.dispatcher_sector_id) || _ctx.state.is_auto_assign_loading
                        ,
            onChange: _ctx.toggleAutoAssign
          }, null, 8, ["value", "disabled", "onChange"]),
          (_ctx.state.is_auto_assign_loading)
            ? (_openBlock(), _createBlock(_component_loader, {
                key: 0,
                class: "primary ml-3"
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_checkbox, {
          value: _ctx.state.status_ids.includes(1),
          label: "Неназначенные заборы",
          disabled: !Boolean(_ctx.state.dispatcher_sector_id),
          onChange: _cache[6] || (_cache[6] = (value) => _ctx.updateStatuses(1, value))
        }, null, 8, ["value", "disabled"]),
        _createVNode(_component_checkbox, {
          value: _ctx.state.status_ids.includes(2),
          class: "ml-5",
          label: "Назначенные заборы",
          disabled: !Boolean(_ctx.state.dispatcher_sector_id),
          onChange: _cache[7] || (_cache[7] = (value) => _ctx.updateStatuses(2, value))
        }, null, 8, ["value", "disabled"]),
        _createVNode(_component_checkbox, {
          value: _ctx.state.is_load_deliveries,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.is_load_deliveries) = $event)),
          class: "ml-5",
          label: "Недоставленные доставки",
          disabled: !Boolean(_ctx.state.dispatcher_sector_id),
          onChange: _ctx.updateIsLoadDeliveries
        }, null, 8, ["value", "disabled", "onChange"])
      ])
    ]),
    _createVNode(_component_orders, {
      class: "mt-6",
      "list-loading": _ctx.take_orders.is_loading,
      orders: _ctx.take_orders.list,
      "selected-order": _ctx.state.selected_order_id,
      card: _ctx.selected_order_state.card,
      "order-number-one-c": _ctx.state.order_number_1c,
      "card-loading": _ctx.selected_order_state.is_loading,
      "card-failed": _ctx.selected_order_state.is_failed,
      "card-error-state": _ctx.selected_order_error_state.error_state,
      "exclude-companies-ids": _ctx.state.exclude_companies_ids,
      "wait-list-status-ids": _ctx.state.wait_list_status_ids,
      "checked-orders-ids": _ctx.state.selected_orders_ids,
      "include-companies-ids": _ctx.state.company_ids,
      onSelect: _ctx.setSelectedOrder,
      onRefreshCard: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadTakeOrder(_ctx.state.selected_order_id))),
      onStartSubmitOrders: _ctx.startSubmitOrders,
      onStartSubmitOrder: _ctx.startSubmitOrder,
      onStartSubmitCheckedOrders: _ctx.startSubmitCheckedOrders,
      onExcludeCompanies: _ctx.updateExcludedCompanies,
      onIncludeCompanies: _ctx.updateIncludedCompanies,
      onSearchBy1c: _ctx.searchBy1C,
      onRefresh: _ctx.reloadOrders,
      onDateChanged: _ctx.onDateChanged,
      onCheckOrder: _ctx.onCheckOrder,
      onWaitStatusesIds: _ctx.updateWaitListStatusIds
    }, null, 8, ["list-loading", "orders", "selected-order", "card", "order-number-one-c", "card-loading", "card-failed", "card-error-state", "exclude-companies-ids", "wait-list-status-ids", "checked-orders-ids", "include-companies-ids", "onSelect", "onStartSubmitOrders", "onStartSubmitOrder", "onStartSubmitCheckedOrders", "onExcludeCompanies", "onIncludeCompanies", "onSearchBy1c", "onRefresh", "onDateChanged", "onCheckOrder", "onWaitStatusesIds"])
  ]))
}